import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { APPCONFIG } from '@config/app.config';
import { IDealerDetails } from '@components/delaerVisit';
import { usePermissionCheckForApiCallback } from '../../../authGuard';

export const useRetrieveDealerVisitDetails = (id: number): IQueryResponse<IDealerDetails> => {
	const { permissionForApi } = usePermissionCheckForApiCallback({ componentName: 'AddDealerVisit' });

	const fetchDealerVisitDetails = async (): Promise<IDealerDetails> => {
		const url = `${APPCONFIG.baseUrl}${APPCONFIG.apiVersion}/dealer-visit/wwa/crud/${id}/`;
		return await APIService.getData<IDealerDetails>(url);
	};
	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['dealerDetails', id],
		queryFn: fetchDealerVisitDetails,
		enabled: permissionForApi && !!id,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
